import React from 'react';

const ComingSoon = ({ pageName = "Page" }) => {
  return (
    <main className="ml-5 w-[73%] max-md:ml-0 max-md:w-full">
      <div className="w-full max-md:mt-8 max-md:max-w-full">
        <header className="flex gap-2.5 items-center py-1.5 text-2xl font-bold text-center whitespace-nowrap border-b border-black border-opacity-10 min-h-12 text-sky-950">
          <h2 className="self-stretch my-auto text-sky-950">{pageName}</h2>
        </header>

        <section className="flex flex-col items-center justify-center px-5 py-20 mt-7 w-full bg-white rounded-2xl shadow-2xl max-md:max-w-full">
          <div className="text-center">
            <div className="text-6xl mb-4">🚧</div>
            <h3 className="text-2xl font-bold text-sky-950 mb-2">{pageName} Coming Soon</h3>
            <p className="text-gray-600 text-lg">
              We're working hard to bring you this feature. Stay tuned!
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ComingSoon;
